import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import GlobalStyles from '../styles/GlobalStyles';
import Footer from './Footer';
// eslint-disable-next-line import/no-cycle
import Header from './Header/index';
// eslint-disable-next-line import/no-cycle
import SubPageHeader from './Header/SubPageHeader';
import Container from './Container';
import { isBlogSection, isHelpCenterSection, isAuthorSection } from '../utils/pageURLCheck';

if (typeof window !== 'undefined') {
  // eslint-disable-next-line global-require
  require('smooth-scroll')('a[href*="#"]');
}

const Main = styled.main`
  padding-top: 1.4rem;
`;

const blogMenu = {
  name: 'Blog Menu',
  links: [
    { name: 'Product', url: '/blog/product' },
    { name: 'Best Practices', url: '/blog/best-practices' },
    { name: 'Customer Stories', url: '/blog/customer-stories' },
  ],
};
const helpMenu = {
  name: 'Help Menu',
  links: [
    { name: 'Getting started', url: '/help/categories/61000063758' },
    { name: 'How to guides', url: '/help/categories/61000063760' },
    { name: 'Account & billing', url: '/help/categories/61000080940' },
    { name: 'Mobile app', url: '/help/categories/61000080939' },
    { name: 'With Slack', url: '/help/categories/61000080941' },
    { name: 'Extensions', url: '/help/categories/61000063757' }
  ],
};
const mainMenu = {
  name: 'Main Menu',
  links: [
    { name: 'Product', url: '/' },
    { name: 'With Slack', url: '/' },
    { name: 'Pricing', url: '/pricing' },
    { name: 'Extensions', url: '/extensions' },
    { name: 'Help Center', url: '/help' },
    { name: 'Blog', url: '/blog' },
    { name: 'API', url: 'http://developers.workast.com/' },
  ],
};
const renderMenu = (location) => {
  if (isBlogSection(location.pathname) || isAuthorSection(location.pathname)) {
    return blogMenu;
  }
  if (isHelpCenterSection(location.pathname)) {
    return helpMenu;
  }
  return mainMenu;
};
const Layout = ({ location, children, isBlogPost }) => (
  <>
    <GlobalStyles theme="light" />
    {isBlogPost ? (
      <SubPageHeader location={location} menu={renderMenu(location)} />
    ) : (
      <Header location={location} menu={renderMenu(location)} />
    )}
    <Main>
      <div>{isBlogPost}</div>
      {location.pathname.indexOf('/blog') > -1 ? (
        <Container>{children}</Container>
      ) : (
        <>{children}</>
      )}
      
    </Main>
    <Footer />
  </>
);

Layout.defaultProps = {
  isBlogPost: false,
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  isBlogPost: PropTypes.bool,
  location: PropTypes.shape({
    host: PropTypes.string,
    hostname: PropTypes.string,
    href: PropTypes.string,
    key: PropTypes.string,
    origin: PropTypes.string,
    pathname: PropTypes.string,
    port: PropTypes.string,
  }).isRequired,
};

export default Layout;
